<template>
  <div class="column_center_center payment_type_popup">
    <div class="column_center_start payment_type_container">
      <text class="title" style="color: #fd5001; margin-bottom: 20px"
        >選擇付款方式</text
      >

      <button
        class="button counter"
        @click="cashPay"
        v-if="isCashPaymentEnabled && !isDeliveryType"
      >
        <text
          id="point_of_sale"
          class="button-icon"
          style="font-size: 34px; width: 34px; height: 34px; margin-right: 10px"
          >point_of_sale</text
        >
        <text>櫃檯結帳</text>
      </button>
      <button
        class="button counter"
        @click="cashPay"
        v-if="isCashPaymentEnabled && isDeliveryType"
      >
        <text
          class="button-icon"
          style="font-size: 34px; width: 34px; height: 34px; margin-right: 10px"
          >shopping_bag</text
        >
        <text>取餐付款</text>
      </button>

      <!-- TODO 根據需求先隱藏 linePay -->
      <button
        class="button line_pay mt-2.5"
        v-if="linePayPaymentMethod"
        :disabled="disableLinePay"
        @click="linepay"
      >
        <div
          class="row_center_center"
          style="
            padding: 3px 7px;
            background-color: #fff;
            color: #03bf5b;
            border-radius: 4px;
            font-weight: 900;
            margin-right: 10px;
          "
        >
          Pay
        </div>
        <text style="color: #fff">LinePay</text>
      </button>
      <div
        class="w-full mt-2 text-sm text-[#FD5001] row_center_center"
        v-if="linePayPaymentMethod && disableLinePay"
      >
       ※ 金額為 0 元，無法使用 LinePay
      </div>
      <div class="w-full my-5 text-base text-[#666666] row_center_center">
        或是
      </div>
      <button @click="close" class="button cancel">返回</button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    disableLinePay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    geturlParameters() {
      return this.$route.params;
    },
    linePayPaymentMethod() {
      return this.$store.getters["payment/linePayPaymentMethod"];
    },
    isCashPaymentEnabled() {
      return this.$store.getters["payment/isCashPaymentEnabled"];
    },
    isDeliveryType() {
      return this.geturlParameters.method === "delivery";
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    cashPay() {
      this.$emit("cashPay");
      this.$emit("close");
    },
    linepay() {
      if (this.disableLinePay) return;
      this.$emit("linePay");
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss">
.payment_type_popup {
  width: 100vw;
  height: 100vh;
  background-color: rgba($color: #000000, $alpha: 0.95);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}

.payment_type_container {
  background-color: #fff;
  padding: 30px 0;
  width: 85%;
  border-radius: 6px;

  .button {
    width: 85%;
    height: 50px;
    border: none;
    font-size: 20px;
    font-weight: 600;
    font-family: PingFang SC;
    color: #000;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.line_pay {
  background-color: #03bf5b;
}

.line_pay:disabled {
  opacity: 0.4;
}

.counter_pay {
  background-color: #fbcb02;
}

.cancel {
  margin: 0 auto;
  background-color: #dddddd;
}

.custom-payment-description {
  width: 85%;
  margin-bottom: 8px;
  padding: 10px 14px;
  font-size: 14px;
  color: #fd5001;
  line-height: 1.5;
  border: 1px solid #fd5001;
  border-radius: 6px;
  display: flex;
  justify-content: center;
}

.custom-payment-inner {
  text-align: left;
}
</style>
